export interface ModDefaults {
  beacon: string;
  minBelt: string;
  maxBelt: string;
  minPipe?: string;
  maxPipe?: string;
  fuel: string;
  cargoWagon: string;
  fluidWagon: string;
  excludedRecipes: string[];
  minMachineRank: string[];
  maxMachineRank: string[];
  moduleRank: string[];
  beaconModule: string;
}
